export default "__VITE_ASSET__91e8812a__"